import { render, staticRenderFns } from "./V2StoresList.vue?vue&type=template&id=932352cc&scoped=true&"
import script from "./V2StoresList.vue?vue&type=script&lang=js&"
export * from "./V2StoresList.vue?vue&type=script&lang=js&"
import style0 from "./V2StoresList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./V2StoresList.vue?vue&type=style&index=1&id=932352cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932352cc",
  null
  
)

export default component.exports